import React, { useMemo } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { arrayOf, objectOf, oneOfType, any } from 'prop-types';

import PageNavigator from '~/components/PageNavigator';

import {
  Container,
  Table,
  THead,
  HeadRow,
  Row,
  TH,
  TD,
  TBody,
  Sort,
  Sorted,
  SortedDesc,
  WrapperNavigator,
} from './styles';

const PrimaryTable = ({ data, columns }) => {
  const dataMemo = useMemo(() => data, [data]);

  const columnsMemo = useMemo(() => columns, [columns]);

  const tableInstance = useTable(
    { columns: columnsMemo, data: dataMemo },
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    pageCount,
  } = tableInstance;

  return (
    <Container>
      <Table {...getTableProps()}>
        <THead>
          {headerGroups.map((headerGroup) => (
            <HeadRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <TH {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <SortedDesc show={column.isSorted && column.isSortedDesc} />
                  <Sorted show={column.isSorted && !column.isSortedDesc} />
                  {!column.isSorted && !column.disableSortBy && <Sort />}
                </TH>
              ))}
            </HeadRow>
          ))}
        </THead>
        <TBody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <Row {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <TD {...cell.getCellProps()}>{cell.render('Cell')}</TD>
                  );
                })}
              </Row>
            );
          })}
        </TBody>
      </Table>
      <WrapperNavigator>
        <PageNavigator
          count={pageCount - 1}
          onChangePage={(newPage) => gotoPage(newPage)}
        />
      </WrapperNavigator>
    </Container>
  );
};

export default PrimaryTable;

PrimaryTable.propTypes = {
  columns: arrayOf(objectOf(oneOfType([any]))).isRequired,
  data: arrayOf(objectOf(oneOfType([any]))).isRequired,
};
